
/////////////////////////////////////
/// REQUIRE PACKAGES
/////////////////////////////////////

	globalThis.appConfig               	= require('../lib/config').getConfig()
	// TODO: MARK: BUNDLER
	globalThis.$ = globalThis.jQuery    = require('jquery')
	globalThis.ClientError          	= require('./error')
	require('./errorHandler')
	const utils         = require('../lib/utils')
	globalThis.componentList   = require('./componentList')
	// TODO: turn this on if mobile testing is your thing and web-developer is not available
	require('./debugConsole')(appConfig, componentList, $)
	const Component       = require('../lib/component')
	globalThis.store           = require('./store')
	store.init()
	let storage         = store.get()
	globalThis.componentTree   = storage.componentTree
	const validator       = require('./validator')

	globalThis.etagResourceHandler   = require('../client/etagResourceHandler')
	const HeartbeatController 	= require('./heartbeatController')




/////////////////////////////////////
/// INIT APP
/////////////////////////////////////

	/**
	 * this function is used to get a component according to a dom-element, a jquery dom-element or an index within the lookup table
	 *
	 * @param   element     	number (index) | object DOM-Element | $ jQuery-DOM-Element
	 * @param   ignoreErrors	boolean - prevent not found error from being thrown
	 * @returns Component | void in an error case
	 */
	globalThis.getComponent = function(element, ignoreErrors){
		// jquery- or dom-object
		if(typeof(element) === 'object'){
			// dom object?
			if(typeof(element.nodeName) !== 'undefined') element = $(element);
			// jquery object?
			if((element instanceof $)){
				var componentIndex = element.data('componentIndex');
				if(typeof(componentIndex) !== 'undefined'){
					return componentTree.lookup[componentIndex];
				}
			}
		}
		// lookup in component tree
		else if(utils.isNumber(element) || utils.isString(element)){
			return componentTree.lookup[element];
		}

		if(!ignoreErrors) throw new Error('Component not found');
	};

	$(document)
		.ready(()=> {
			// set root route of the actual load request
			globalThis.rootRoute = globalThis.route

			// set base headers for all requests
			$.ajaxSetup({
				contentType:        'application/json; charset=utf-8',
				dataType:			'json',
				headers: {
					Accept:             'application/json; charset=utf-8',
					'fec_root_route':   globalThis.route,
					'fec_base_route':   globalThis.route,
					'fec_full_route':   globalThis.fullRoute
				}
			})

			// update client storage if necessary
			if(globalThis.updateClientStorage){
				if(globalThis.updateClientStorage.session && globalThis.updateClientStorage.session.user && storage.user && utils.isFunction(storage.user.reset)){
					storage.user.reset()
				}
				storage = store.set(globalThis.updateClientStorage, undefined, undefined, undefined, undefined, false)
			}
			globalThis.storage = storage

			// init validators if necessary
			if(storage.app && storage.app.validators && storage.app.validators.data){
				validator.initValidators(storage.app.validators.data)
			}

			// print viewMode
			let sco
			if((sco = (((storage || {}).user || {}).data || {}).serviceCollectionOptions)){
				console.log('### INIT - ServiceCollectionOptions:', sco)
			}

			// register global actions
			componentTree.globalActionsByScope = globalThis.globalActionsByScope || {}

			// build component tree
			componentTree.build(globalThis.route, globalThis.tree, true, true, true, storage, {}, undefined, {}, undefined, {})

			// add errorParent component to componentTree
			componentTree.lookup.errorParent = new Component({ component: ['collection'], componentIndex: 'errorParent' }, appConfig.requestIDFallback, appConfig.sessionIDFallback, appConfig.serviceDomainFallback)

			// cleanup
			globalThis.tree = {}

			// TODO: NEEDED?
			if(!globalThis.routeParams){
				globalThis.routeParams = {}
			}

			let $dynamicJSSources
			if(($dynamicJSSources = $('script.dynamicJSSources')).length > 0){
				$dynamicJSSources.remove()
			}

			// propagate visibility change if necessary
			document.addEventListener('visibilitychange', () => {
				componentTree.callHandler('onDocumentVisibilityChanged', document.hidden)
				if(globalThis.heartbeatController){
					globalThis.heartbeatController.onDocumentVisibilityChanged(document.hidden)
				}
			})

			// attach component tree to dom
			;(async () => {
				await componentTree.trigger(undefined, 'attach', {}, true)
				await componentTree.trigger(undefined, 'postAttach', {}, true)
				globalThis.heartbeatController = new HeartbeatController(storage)
			})()
		})
	;